import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import DeviceCard from '../elements/DeviceCard';
import Button from '../elements/Button';
import SendButton from '../elements/SendButton';
import Heading from '../elements/PageHeading';
import QRIdInput from '../elements/QRIdInput.js';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: auto;
  color: ${props => props.theme.secondary};
`;

const Label = styled.div`
  margin: 30px auto 0px;
  color: ${props => props.theme.primary};
  font-size: 20px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 50px auto 0px;
  width: 360px;
`;

const Attention = styled.div`
  background: ${props => props.theme.attentionTint};
  color: ${props => props.theme.secondary};
  width: 360px;
  padding: 15px;
  box-sizing: border-box;
  margin: 20px auto 0px;
  text-align: center;
`;

class ReplacementPage extends Component {
  state = {
    replacementInput: '',
  };

  render() {
    const {
      t,
      target,
      replacement,
      cancel,
      replace,
      fetchReplacement,
    } = this.props;

    return (
      <Wrapper>
        <Heading text={t('management.replace')} />
        <DeviceCard device={target || {}} />
        <Label>with</Label>
        {replacement ? (
          <DeviceCard device={replacement || {}} />
        ) : (
          <>
            <Label>{t('management.replacement_id_label')}</Label>
            <QRIdInput
              input={this.state.replacementInput}
              onChange={value => {
                this.setState({ replacementInput: value });
              }}
            />
          </>
        )}
        <>
          {replacement ? (
            <Attention>{t('management.replacement_warning')}</Attention>
          ) : null}
          <Buttons>
            <Button onClick={cancel}>{t('button.cancel')}</Button>
            {!replacement ? (
              <SendButton
                onClick={() => fetchReplacement(this.state.replacementInput)}
                text={t('button.continue')}
                disabled={this.state.replacementInput.length < 1}
              />
            ) : (
              <SendButton
                onClick={() => replace()}
                text={t('button.confirm')}
              />
            )}
          </Buttons>
        </>
      </Wrapper>
    );
  }
}

export default translate()(ReplacementPage);
